import { render, staticRenderFns } from "./CandidateSharedLink.vue?vue&type=template&id=584f1a1a&scoped=true&"
import script from "./CandidateSharedLink.vue?vue&type=script&lang=js&"
export * from "./CandidateSharedLink.vue?vue&type=script&lang=js&"
import style0 from "./CandidateSharedLink.vue?vue&type=style&index=0&id=584f1a1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584f1a1a",
  null
  
)

/* custom blocks */
import block0 from "./CandidateSharedLink.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./CandidateSharedLink.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VContainer})
